import axios from 'axios';
import { Email_URI } from './apiVersionConstants';

export default {
    async sendEmail(data){
        try {
            return await axios.post(`${Email_URI}`, data);
        }catch (error){
            return error.response;
        }
    },

    async verifyRecaptcha(data){
      try {
        return await axios.get(`${Email_URI}/verify?userResponse=${data}`)
      }catch (error){
        return error.message;
      }
    }
}